import Separator from './assets/separator.svg?react';

import styles from './Footer.module.scss';

const currentYear = new Date().getFullYear();

export const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <p className={styles.copyright}>&copy; {currentYear} Self Inspection, Inc.</p>

        <div className={styles.linksContainer}>
          <a href="#" className={styles.link} target="_blank" rel="noopener noreferrer">
            Terms and Conditions
          </a>
          <Separator />
          <a href="#" className={styles.link} target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
          <Separator />
          <a href="#" className={styles.link} target="_blank" rel="noopener noreferrer">
            CA Privacy Notice
          </a>
        </div>
      </div>
    </footer>
  );
};
